import './savethedate.css'
import dayjs from 'dayjs'
import { ReactComponent as Illus1 } from '../../../../../images/hand.svg'

const Savethedate = ({details}) => {

  return (
   <section className={`save-the-date ${details?.theme || ''}`}  >
    {/* <Illus1 className="save-date-illustration" data-aos="fade-up" data-aos-offset={800}/> */}
     {details?.userCode !== 'o47gbubt1' && (
  <Illus1
    className="save-date-illustration"
    data-aos="fade-up"
    data-aos-offset={800}
  />
)}
    <h1   data-aos="fade-up" style={details?.userCode === "o47gbubt1" ? { paddingTop: "50px" } : {}} >Our Forever Begins</h1>
    <h3  data-aos="fade-up">  {details?.weddingDate
          ? dayjs(details.weddingDate).format('DD.MM.YY')
          : ''}</h3>
         <span className='opening-message'  data-aos="fade-up" >{details?.blessingMessage}</span> 
   </section>
  )
}

export default Savethedate